import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a31d122"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pageBox layoutBox" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("热门问题")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("列表")
const _hoisted_4 = { class: "page_main" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hotIssue_item_title_label" }, null, -1))
const _hoisted_7 = { class: "hotIssue_item_describe" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavBox = _resolveComponent("NavBox")!
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_page_header = _resolveComponent("el-page-header")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_NavBox, {
      selectedItem: _ctx.selectedItem,
      "onUpdate:selectedItem": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedItem) = $event))
    }, null, 8, ["selectedItem"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_page_header, {
        content: "detail",
        onBack: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.go(-1)))
      }, {
        content: _withCtx(() => [
          _createVNode(_component_el_breadcrumb, { "separator-icon": "arrow-right-bold" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_breadcrumb_item, null, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }),
              _createVNode(_component_el_breadcrumb_item, null, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_ctx.list)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_4, [
              (_ctx.list.length)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.list, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "hotIssue_item",
                      key: item.id
                    }, [
                      _createElementVNode("div", {
                        class: "hotIssue_item_title",
                        onClick: ($event: any) => (_ctx.onDetails(item.id))
                      }, [
                        _hoisted_6,
                        _createElementVNode("span", null, _toDisplayString(item.name), 1)
                      ], 8, _hoisted_5),
                      _createElementVNode("div", _hoisted_7, _toDisplayString(item.answer), 1)
                    ]))
                  }), 128))
                : (_openBlock(), _createBlock(_component_el_empty, {
                    key: 1,
                    description: "暂无内容"
                  }))
            ]),
            _createVNode(_component_el_pagination, {
              class: "TablePagination",
              background: "",
              onSizeChange: _ctx.handleSizeChange,
              onCurrentChange: _ctx.handleCurrentChange,
              "current-page": _ctx.query.page,
              "page-sizes": [20, 40, 60, 100],
              "page-size": _ctx.query.paginate,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _ctx.total
            }, null, 8, ["onSizeChange", "onCurrentChange", "current-page", "page-size", "total"])
          ], 64))
        : _createCommentVNode("", true)
    ])
  ]))
}